<template>
  <div class="ai-assistant-container">
    <el-card>
      <div slot="header"><span>AI助手设置</span></div>
      <el-form label-width="100px" size="small">
        <el-form-item label="助手头像">
          <el-upload action="" :show-file-list="false" :before-upload="beforeUpload" :http-request="handleUpload">
            <img v-if="form.avatarUrl" :src="form.avatarUrl" style="width:80px;height:80px;border-radius:50%;object-fit:cover" />
            <div v-else class="upload-btn"><i class="el-icon-plus"></i></div>
          </el-upload>
        </el-form-item>
        <el-form-item><el-button type="primary" @click="save">保存</el-button></el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import request from '@/utils/request'
import { getCommunityId } from '@/api/community/communityApi'
export default {
  data() {
    return { form: { avatarUrl: '' } }
  },
  created() { this.load(); },
  methods: {
    async load() {
      try {
        const res = await request({ url: '/ai.listAssistantConfig', method: 'get', params: { communityId: getCommunityId(), page: 1, row: 1 } });
        const data = res.data;
        if (data.code === 0 && data.data) {
          const config = Array.isArray(data.data) ? data.data[0] : data.data;
          this.form.avatarUrl = config.avatarUrl || '';
        }
      } catch(e) { /* no config yet */ }
    },
    beforeUpload(file) {
      const isImage = file.type.includes('image/');
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isImage) { this.$message.error('只能上传图片'); return false; }
      if (!isLt10M) { this.$message.error('图片不能超过10MB'); return false; }
      return true;
    },
    async handleUpload({ file }) {
      const formData = new FormData();
      formData.append('uploadFile', file);
      const res = await request({ url: '/callComponent/upload/uploadFile/uploadImage', method: 'post', data: formData });
      const data = res.data;
      if (data.code === 0) { this.form.avatarUrl = data.url || res.data.url; this.$message.success('上传成功'); }
      else { this.$message.error('上传失败'); }
    },
    async save() {
      try {
        await request({ url: '/ai.saveAssistantConfig', method: 'post', data: { communityId: getCommunityId(), avatarUrl: this.form.avatarUrl, enabled: '1' } });
        this.$message.success('保存成功');
      } catch(e) { this.$message.error('保存失败'); }
    }
  }
}
</script>
<style scoped>
.ai-assistant-container { padding: 20px; }
.upload-btn { width: 80px; height: 80px; display: flex; align-items: center; justify-content: center; border: 1px dashed #d9d9d9; border-radius: 6px; cursor: pointer; }
.upload-btn:hover { border-color: #409eff; }
</style>
